import script from "./TableDataDoctor.vue?vue&type=script&setup=true&lang=js"
export * from "./TableDataDoctor.vue?vue&type=script&setup=true&lang=js"

import "./TableDataDoctor.vue?vue&type=style&index=0&id=e92f6de2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e92f6de2"]])

export default __exports__